import { useState } from 'react';
import { Link } from '@material-ui/core';
import { Flag } from '@material-ui/icons';
import { Inline } from '@superdispatch/ui';
import { LoadSuggestionsFeedbackDialog } from './LoadSuggestionsFeedbackDialog';
import { LoadSuggestionDTO } from './data/LoadSuggestionDTO';
import { Button } from '@superdispatch/ui-lab';

interface Props {
  load: LoadSuggestionDTO;
}

export function LoadSuggestionsFeedbackLink({ load }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Inline>
        <Flag color="action" fontSize="small" />
        <Link
          href="#"
          data-intercom-target="Report load suggestion"
          onClick={(event) => {
            event.preventDefault();
            setOpen(true);
          }}
        >
          Report suggestion
        </Link>
      </Inline>

      <LoadSuggestionsFeedbackDialog
        open={open}
        load={load}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}

export function LoadSuggestionsFeedbackButton({ load }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="inverted"
        onClick={() => {
          setOpen(true);
        }}
      >
        Report suggestion
      </Button>

      <LoadSuggestionsFeedbackDialog
        open={open}
        load={load}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
